export default [
    {
        path: '/oldPanel/list',
        name: 'Old_Panel_List',
        component: () => import('@/views/oldPanel/list.vue'),
        meta: {
            authRequired: true,
            // permission: 'requests.index'
        }
    },
    {
        path: '/oldPanel/show/:id',
        name: 'Old_Panel_Show',
        component: () => import('@/views/oldPanel/show.vue'),
        meta: {
            authRequired: true,
            permission: 'oldData'
        }
    },
]
